import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { SHIPPING_CONNECTION_CODE } from '../../../../../../models/IntegrationsTypes';
import ShippingOAuthHandler from '../oauth-handler/shipping-oauth-handler';

interface IUspsDirectOauthCredentials {
    accountId: string;
    mailerId: string;
}

class UspsDirectOauthCredentialsStore implements ICredentialsStore {
    private _oauthHandler = new ShippingOAuthHandler(SHIPPING_CONNECTION_CODE.USPS_DIRECT_OAUTH);
    private _changes: IUspsDirectOauthCredentials = {} as IUspsDirectOauthCredentials;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get accountId() {
        return this._changes.accountId;
    }

    public setAccountId(value: string) {
        this._changes.accountId = value;
    }

    public get mailerId() {
        return this._changes.mailerId;
    }

    public setMailerId(value: string) {
        this._changes.mailerId = value;
    }

    public async getCredentials(isSandbox = false) {
        return this._oauthHandler.getCredentials(this._changes, isSandbox);
    }
}

export default UspsDirectOauthCredentialsStore;
